import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../../../store/components/modelSlice';
import { postActivityPush } from '../../../../services/dashboard/battery';
import { message } from 'antd';

const ActivityPush = () => {
    const dispatch = useDispatch();
    const content = useSelector((state) => state.model.data);
    const cancelHandler = () => { dispatch(resetModel()); };

    const handleSubmit = () => {
    
        postActivityPush(content.vehicleTasksMasterId)
            .then(response => {
                cancelHandler();
                message.success('發送成功');
            })
            .catch(error => {
                console.error('Error:', error); 
            });
    };
    
    return (
        <Modal className='activity-push-model' show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">確認發送此推播？</div>
                <div className="button-container">
                    <Button variant="secondary" data-shadow onClick={ cancelHandler }>關閉</Button>
                    <Button variant="primary" data-shadow onClick={ handleSubmit }>確認發送</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default ActivityPush;